import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import _ from 'lodash';
import moment from 'moment';
import { Calendar, Views, momentLocalizer } from 'react-big-calendar';
import 'moment/locale/he';
import './EventsCalendar.scss';

const localizer = momentLocalizer(moment);

const convertToCalendarEvents = events => {
    return events.map(event => ({
        ...event,
        start: moment(event.startDate).toDate(),
        end: moment(event.endDate).toDate(),
        allDay: true,
        meta: event.meta || {}
    }));
};

const convertToDbCampaign = event => {
    return ({
        id: event.id,
        title: event.title,
        description: event.description,
        startDate: event.start,
        endDate: event.end,
        chainId: event.chainId,
        branchIds: event.branchIds,
        brandKey: event.brandKey,
        platform: event.platform,
        meta: event.meta
    });
};

const EventsCalendar = (props) => {
    const calendarEvents = convertToCalendarEvents(props.events);

    return (
        <Calendar
            selectable
            localizer={localizer}
            events={calendarEvents}
            resizable
            culture={i18next.language}
            views={['month', 'agenda']}
            defaultView={Views.MONTH}
            defaultDate={moment().toDate()}
            style={{ height: 500 }}
            messages={{
                next: i18next.t('calendar.next'),
                today: i18next.t('calendar.today'),
                previous: i18next.t('calendar.previous'),
                month: i18next.t('calendar.month'),
                agenda: i18next.t('calendar.agenda'),
            }}
            rtl={i18next.dir() === 'rtl'}
            eventPropGetter={(event) => ({ style: { backgroundColor: event.meta.color } })}
            onSelectEvent={(event) => props.handleEventClick(convertToDbCampaign(event))}
        />
    );
};

EventsCalendar.propTypes = {
    events: PropTypes.array,
    handleEventClick: PropTypes.func
};

export default EventsCalendar;
